import styled from 'styled-components'
import { smStyle } from '@/components/Adapter'

export const PriceRecStyled = styled.div`
  width: 100%;
  margin-bottom: 18px;

  ${smStyle} {
    margin-bottom: 0;
  }
`

export const PriceRecGtXsStyled = styled.div`
  width: 100%;
  position: relative;
  .mantine-Carousel-indicator {
    border-radius: 50%;
  }
  .mantine-GateCarousel-indicators {
    bottom: -17px;
  }
`
